import React, { useMemo } from 'react';
import { generatePath, useHistory, useLocation, useRouteMatch } from 'react-router-dom';

import {
  SettingsManager,
  useLabel,
  useSportsbookState,
  useSportsbookStateUpdate,
} from '@atlas/core';
import { Icon } from '@atlas/ui';

const amountOfHours = [24, 12, 6, 3, 1];
const allTimeName = 'all_time';
export const timeQueryName = 'time';

export const isValidTimeFilter = time => !isNaN(time) && amountOfHours.includes(parseInt(time));

const DropdownTime = () => {
  const sportsbookStateUpdate = useSportsbookStateUpdate();
  const { selectedCategoryUrlName, selectedSportUrlName } = useSportsbookState();
  const { search } = useLocation();
  const { path } = useRouteMatch();
  const history = useHistory();

  const timeQuery = new URLSearchParams(search).get(timeQueryName);

  const params = { categoryName: selectedCategoryUrlName, sportName: selectedSportUrlName };
  const toUrl = generatePath(path, params);

  const timeFilter = amountOfHours.map(hours => ({
    timeHours: hours,
    title: useLabel(`${hours}h`),
  }));

  timeFilter.unshift({
    timeHours: null,
    title: useLabel(allTimeName),
  });

  const handleSetActiveTime = timeHours => {
    const url = timeHours ? `${toUrl}?${timeQueryName}=${timeHours}` : toUrl;
    const filter = {
      dateFilterType: timeHours ? `${timeHours}h` : null,
      timeHours: timeHours || null,
    };

    SettingsManager.updateSettings({ resetFilter: {} });

    sportsbookStateUpdate({
      categoryFilter: filter,
      tournamentFilter: filter,
    });

    history.push(url);
  };

  const allTimeLabel = useLabel(allTimeName);
  const selectedTimeValue = useMemo(() => {
    if (isValidTimeFilter(timeQuery)) {
      return timeFilter.find(time => time.timeHours === JSON.parse(timeQuery)).title;
    }
    return allTimeLabel;
  }, [timeQuery]);

  return (
    <div className="dropdown bg select-field-container">
      <div className="dropdown-button">
        <div className="dropdown-button__text">{selectedTimeValue}</div>
        <Icon className="dropdown-button__icon-right" name="arrow-down" />
      </div>
      <select
        className="select-field"
        onChange={e => {
          const selectedOption = timeFilter.find(option => option.title === e.target.value);
          handleSetActiveTime(selectedOption.timeHours);
        }}
        value={selectedTimeValue}
      >
        {timeFilter.map((option, index) => (
          <option key={index} value={option.title}>
            {option.title}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropdownTime;
